// extracted by mini-css-extract-plugin
export default {"restaurantCard":"marketCard_restaurantCard__KhYF2","containerImg":"marketCard_containerImg__3DCL+","imgRestaurant":"marketCard_imgRestaurant__tLvBf"};